/* globals _refersion _rfsn */
import { logWithOffset } from "../../logWithOffset";
let settings = null;

const isEnabled = () => {
  return typeof(settings.refersionPubKey) === 'string' && settings.refersionPubKey.length > 0;
};

const setup = async (s) => {
  settings = s;
  if (isEnabled()) {
    setTimeout(() => {
      logWithOffset("Configuring Refersion");
      const head      = document.getElementsByTagName('head')[0];
      const newScript = document.createElement("script");
      newScript.src   = `//www.refersion.com/tracker/v3/${settings.refersionPubKey}.js`;
      newScript.async = false;
      head.appendChild(newScript);
    }, 2500)
  }
};

const handlePageView = async (e) => {
  if (typeof window._refersion === 'undefined') {
    setTimeout(()=> { handlePageView(e) }, 500);
    return;
  } else {
    _refersion(function(){ _rfsn._addCart(e.sessionCartId); });
  }
}

const fire = async (e) => {
  if (!isEnabled()) {
    return;
  }

  switch(e.eventType) {
    case 'page_view':
      return handlePageView(e);
  }
};

export default { setup, fire };
